// extracted by mini-css-extract-plugin
export default {"tabSelectBox":"tab-switch_tabSelectBox__ZxpBp","tabSelectBoxMobile":"tab-switch_tabSelectBoxMobile__qvnMD","buttonTab":"tab-switch_buttonTab__9I3UQ"};